import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'; // Element plus
import 'element-plus/dist/index.css'
import router from './router'
import './assets/scss/index.scss'
import { zhCn } from 'element-plus/es/locales.mjs';


const app = createApp(App)
app.use(ElementPlus, { locale: zhCn })
// ElIcons 全局引用
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
app.use(router)
app.mount('#app')
